// AI Generated File
import { Component, Input, Output, EventEmitter, OnInit } from '@angular/core';
import { PolicyService } from '@client/app/services/entities/policy/policy.service';

import { safeClone } from '@client/app/shared/utils/object-utils';
@Component({
    selector: 'form-global-policy-dialog-save',
    templateUrl: './save.html',
    standalone: false,
})
export class FormGlobalPolicyDialogSaveComponent implements OnInit {
    @Input() resolve: any;
    @Output() close = new EventEmitter<any>();
    @Output() dismiss = new EventEmitter<any>();

    policy: any;
    saving = false;
    closeButtonHover = false;
    form: any = {};

    constructor (
        private policyService: PolicyService,
    ) {}

    ngOnInit (): void {
        this.policy = safeClone(this.resolve.policy);
        this.saving = false;
    }

    submit (): void {
        let promise: Promise<any>;
        this.saving = true;

        if (this.policy.id) {
            promise = this.policyService.update(this.policy);
        } else {
            promise = this.policyService.create(this.policy);
        }

        promise
            .then(
                (policy) => {
                    return this.policyService.run(policy.id).then(() => {
                        return policy;
                    }, () => {
                        return policy;
                    });
                },
                () => {
                    this.saving = false;
                },
            )
            .then((policy) => {
                setTimeout(() => this.close.emit({ $value: policy }), 200); // Some policies takes a little to start for the api
            }, () => {});
    }
}
